import { ApiSanctionAlert, ApiSortDirection, screeningAlertFilterResultsApi } from '../../../apis';
import { showFeedback } from '../../../feedback/feedbackReducer';
import store from '../../../store/store';
import { Dispatch } from 'redux';
import { NavigateFunction } from 'react-router';
import { showConfirmationModal } from '../../../confirmation-modal/confirmationModalReducer';
import { parseErrorMessage } from '../../../common/errors/helpers';

export const fetchFilterMatchingScreeningAlerts = async (
  filterId: number,
  direction: ApiSortDirection,
  size: number,
  offsetId?: number,
  offsetCreatedTime?: Date
): Promise<{ alerts: ApiSanctionAlert[]; filterId: number } | undefined> => {
  try {
    const result = await screeningAlertFilterResultsApi.findFilterResults({
      filterId,
      direction,
      size,
      offsetId,
      offsetCreatedTime,
    });

    return {
      alerts: result.alerts,
      filterId,
    };
  } catch (e) {
    store.dispatch(showFeedback({ message: await parseErrorMessage(e) }));
  }
};

export const assignAndGoToNextScreeningAlertInFilter =
  (filterId: number, direction: ApiSortDirection, navigate: NavigateFunction, offsetId?: number) =>
  (dispatch: Dispatch) => {
    screeningAlertFilterResultsApi
      .assignNextFromFilter({
        filterId,
        direction,
        offsetId,
      })
      .then((assignedAlert) => {
        if (assignedAlert.screeningAlertId) {
          navigate(
            `/screening/alerts/${assignedAlert.screeningAlertId}?flow=true&filterId=${filterId}&direction=${direction}`
          );
        } else {
          showConfirmationModal({
            title: '',
            description:
              'No more alerts left in filter to assign to you. Either filter is empty of alerts or alerts have' +
              ' been assigned to other users.',
            confirmationText: 'Ok',
            onConfirm: () => undefined,
          })(dispatch);
        }
      })
      .catch(async (e) => {
        dispatch(showFeedback({ message: await parseErrorMessage(e) }));
      });
  };
